import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-crm-pipeline',
  templateUrl: './crm-pipeline.component.html',
  styleUrls: ['./crm-pipeline.component.css'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrmPipelineComponent implements OnInit {

  isLoading = true;
  stages: any[] = [];
  opportunities: any[] = [];
  opportunitiesByStage = new Map<string, any[]>();

  constructor(
    private dataService: DataService,
    private localStorage: StorageService,
    private titleService: Title,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('CRM Pipeline');
    this.loadPipeline();
    this.loadOpportunities();
  }

  private companyParam(prefix = '?'): string {
    const id = this.localStorage.StorageGet('default_company_id', '');
    return id ? prefix + 'company_id=' + encodeURIComponent(id) : '';
  }

  loadPipeline(): void {
    const pipelineUrl = 'crm/pipeline' + this.companyParam();
    this.dataService.getData(pipelineUrl).subscribe({
      next: (result: any) => {
        this.stages = result ?? [];
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  loadOpportunities(): void {
    const oppsUrl = 'crm/opportunities?status=open' + this.companyParam('&');
    this.dataService.getData(oppsUrl).subscribe({
      next: (result: any) => {
        console.log('loadOpportunities result:', result);
        this.opportunities = result?.items ?? result ?? [];
        this.buildOpportunitiesMap();
        this.cdr.markForCheck();
      },
      error: () => {
      }
    });
  }

  private buildOpportunitiesMap(): void {
    const map = new Map<string, any[]>();
    for (const o of this.opportunities) {
      const key = o.stageId || o.stage_id || '';
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)!.push(o);
    }
    this.opportunitiesByStage = map;
  }

  opportunitiesForStage(stageId: string): any[] {
    return this.opportunitiesByStage.get(stageId) ?? [];
  }
}
